// MODIFIED: Refactored to use unified salaryAdvanceService
import { useState, useCallback, useEffect } from "react";
import salaryAdvanceService from "../services/salaryAdvanceService";

export const useFinancialApprover = () => {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [approverList, setApproverList] = useState([]);

	const fetchData = useCallback(async () => {
		setLoading(true);
		try {
			const response = await salaryAdvanceService.getHierarchyList();
			setData(response);
			setFilteredData(response);
		} catch (err) { console.error("v2: Hierarchy Fetch Error", err); }
		finally { setLoading(false); }
	}, []);

	const fetchApproverList = useCallback(async () => {
		try {
			const response = await salaryAdvanceService.getPotentialApprovers();
			setApproverList(response);
		} catch (err) { console.error("v2: Approver List Fetch Error", err); }
	}, []);

	useEffect(() => {
		fetchData();
		fetchApproverList();
	}, [fetchData, fetchApproverList]);

	const handleFilter = (val) => {
		if (!val) return setData(filteredData);
		const low = val.toLowerCase();
		setData(filteredData.filter(f => f.fullName?.toLowerCase().includes(low) || f.employeeId?.toString().includes(low)));
	};

	const saveApproverHierarchy = async ({ selectedEmployee, approverHierarchyCount, hierarchyLevels }) => {
		setLoading(true);
		try {
			const details = [];
			hierarchyLevels.forEach((lv, idx) => {
				lv.forEach(slot => { if (slot.approverId) details.push({ approverId: slot.approverId, hierarchy: idx + 1 }); });
			});

			const payload = {
				employeePersonalInformationId: selectedEmployee.id,
				approverHierarchyCount,
				details
			};

			await salaryAdvanceService.saveHierarchy(payload, selectedEmployee.mainApproverId);
			await fetchData();
			return { success: true };
		} catch (err) { return { success: false, error: err }; }
		finally { setLoading(false); }
	};

	return { loading, data, approverList, handleFilter, saveApproverHierarchy };
};